module.exports = __webpack_public_path__ + "static/media/banff-26.ad3bbc16.jpg";